import { PropsWithChildren } from 'react';

import { AppShell, Divider, Flex, Group, Text } from '@mantine/core';

import { Profile } from '@/widgets/profile';

import LogoText from './logo-text.svg?react';

export function Layout({ children }: PropsWithChildren) {
  return (
    <AppShell
      layout="alt"
      header={{ height: 65 }}
      navbar={{ breakpoint: 'md', width: 300 }}
      padding={20}
      bg="gray.0"
    >
      <AppShell.Header>
        <Flex align="center" h="100%" px={20}>
          <Text size="lg" fw={650} tt="uppercase">
            Your Apps
          </Text>
        </Flex>
      </AppShell.Header>

      <AppShell.Navbar>
        <Group
          component={AppShell.Section}
          h={64}
          py={16}
          pl={20}
          pr={14}
          gap={12}
          align="center"
          wrap="nowrap"
        >
          <LogoText width={120} height={64} />
        </Group>

        <Divider mx={10} />

        <AppShell.Section grow />

        <Divider mx={10} />

        <AppShell.Section py={16} px={10}>
          <Profile />
        </AppShell.Section>
      </AppShell.Navbar>

      <AppShell.Main style={{ height: '100dvh', overflow: 'auto' }}>
        {children}
      </AppShell.Main>
    </AppShell>
  );
}
